import Box from '@/components/ui/Box/Box';
import Typography from '@/components/ui/Typography/Typography';
import type { PageProps } from './IPage';
import { styles } from './styles';

const Page = ({ title, actions, children }: PageProps) => (
    <Box sx={styles.container}>
        {(title || actions) && (
            <Box sx={styles.titleRow}>
                {title && (
                    <Typography variant="h1" sx={styles.title}>
                        {title}
                    </Typography>
                )}
                {actions && <Box>{actions}</Box>}
            </Box>
        )}
        <Box sx={styles.content}>{children}</Box>
    </Box>
);

export default Page;
